import { Text, Spacer, Image } from '@vinted/web-ui'

type Props = {
  imageSrc: string
  title: string
  body: string
}

const Block = ({ imageSrc, title, body }: Props) => {
  return (
    <div className="grid4 u-ui-padding-bottom-x3-large@portables">
      <Image src={imageSrc} styling={Image.Styling.Rounded} />
      <Spacer size={Spacer.Size.Large} />
      <Text as="span" width={Text.Width.Parent} html>
        <span className="c-text--responsive-large-title">{title}</span>
      </Text>
      <Spacer size={Spacer.Size.Medium} />
      <Text as="span" width={Text.Width.Parent} html>
        <span className="c-text--responsive-small-body">{body}</span>
      </Text>
    </div>
  )
}

export default Block
